import { IClickEventData } from 'types/analytics';

export const HEADER_ANALYTICS_ATTRIBUTES: IClickEventData = {
    location: 'Navigation',
    category: 'Action',
    action: 'Ubisoft.com'
};
